import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';
import theme from 'styles/theme';

export const TabContainerChildWrapper = styled.div`
  .nav {
    display: grid;
    grid-auto-flow: column;

    ${mediaQuery.sm} {
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(2, 100px);
    }

    > .rating-category-nav-item.active {
      background-color: ${theme.colors.bgHover};
      border: none;
    }

    &::before {
      display: none;
    }
  }

  .rating-category {
    align-items: start;
    color: ${theme.colors.fontDark};
    display: flex;
    flex-direction: column;
    font-weight: bold;
    gap: 10px;

    span:first-child {
      font-size: 14px;
    }

    span:last-child {
      font-size: 24px;
    }
  }

  .rating-category-nav-item {
    border: 0;
    color: inherit;

    &,
    &.active {
      a[role='tab'] {
        background-color: transparent;
      }
    }

    a[role='tab'] {
      height: 100%;
    }

    a[role='tab']:hover {
      background-color: ${theme.colors.bgHover};
    }
  }

  .tab-content {
    margin-top: 30px;
    min-height: 350px;

    ul {
      margin-top: 10px;
    }

    li {
      display: flex;

      span:first-child {
        flex: 1;
      }

      svg {
        height: 16px;
        width: 16px;
      }

      &.done {
        span:first-child {
          text-decoration-line: line-through;
        }
      }

      .state {
        align-items: center;
        display: flex;
        gap: 5px;

        &.done {
          color: ${theme.colors.bgGreen};
        }

        &:not(.done) {
          color: ${theme.colors.hostfullyOrange};
        }
      }
    }
  }
`;
